import { e } from "./engine-user-agent.js";
var r = /MSIE|Trident/.test(e);
export { r as e };